import { render, staticRenderFns } from "./common-footer.vue?vue&type=template&id=dd0f5298&scoped=true"
import script from "./common-footer.vue?vue&type=script&lang=js"
export * from "./common-footer.vue?vue&type=script&lang=js"
import style0 from "./common-footer.vue?vue&type=style&index=0&id=dd0f5298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0f5298",
  null
  
)

export default component.exports